const appSupportLink = 'https://sravni.onelink.me/cyn1/1edwjpag';

export { appSupportLink };
//# sourceMappingURL=appSupportLink.js.map
